export default __webpack_public_path__ + "static/media/balance.8df8d049.svg";